import React from 'react';
import Container from 'app/common/narrow-container';
import Paper from '@mui/material/Paper';
import Button from 'app/common/button';
import Input from 'app/common/form/input';
import { useMutation } from '../hooks/useMutation';

const REQ_RESET_PASSWORD = `
query ReqResetPassword($email: String!) {
    reqResetPassword(email: $email)
}
`;

const ForgotPassword = () => {
  const { mutate } = useMutation(REQ_RESET_PASSWORD);
  const [email, setEmail] = React.useState(null);
  const [isSend, setIsSend] = React.useState(false);

  const onSubmitHandler = async (ev) => {
    ev.preventDefault();
    const { data } = await mutate({ email });
    if (data && data.reqResetPassword) {
      setIsSend(data.reqResetPassword);
    }
  };

  const onChangeHandler = (ev) => {
    setEmail(ev.currentTarget.value);
  };

  return (
    <Container header="Glemt adgangskode">
      <Paper
        component="form"
        className="login"
        onSubmit={onSubmitHandler}
        style={{ marginBottom: '1em', padding: '1em' }}
      >
        {isSend ? (
          `Vi sender en mail til ${email}, hvis vi har den`
        ) : (
          <>
            <Input
              fullWidth
              name="email"
              onChange={onChangeHandler}
              required
              type="email"
              label="Email"
            />
            <div
              style={{
                display: 'flex',
                justifyContent: 'space-between',
                marginTop: '1em'
              }}
            >
              <div>
                <Button type="submit" primary label="Nulstil adgangskode" />
                <Button
                  to="/signup"
                  primary
                  flat
                  label="Ny udlejer?"
                  style={{ marginLeft: 8 }}
                />
              </div>
              <div>
                <Button to="/" primary flat label="Log ind" />
              </div>
            </div>
          </>
        )}
      </Paper>
      {__DEV__ && (
        <Button onClick={() => setIsSend(false)} primary label="reset state" />
      )}
    </Container>
  );
};

export default ForgotPassword;